<div class="modal-header">
  <h6 class="modal-title">ครอบรูปโปรไฟล์</h6>
  <button type="button" class="btn-close btn-close-sm" aria-label="ปิด" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <div class="crop-stage">
    <canvas #cropCanvas class="crop-canvas" (pointerdown)="onPointerDown($event)"></canvas>
  </div>
  <div class="zoom-control">
    <i class="bi bi-zoom-out"></i>
    <input type="range" class="form-range mx-2" [min]="minZoom" [max]="maxZoom" [step]="0.001" [value]="zoom" (input)="onZoomInput($event)">
    <i class="bi bi-zoom-in"></i>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default me-auto" (click)="resetCrop()">
    <i class="bi bi-arrow-counterclockwise"></i>
  </button>
  <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">ยกเลิก</button>
  <button type="button" class="btn btn-primary" (click)="confirm()">
    <i class="bi bi-check2 me-1"></i>ยืนยัน
  </button>
</div>
